<template>
    <div>
        <vx-card title="BankInformation" subtitle="Lists of Bank Informations"  class="no-scroll-content" >


        <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
        <vs-button type="gradient" color="primary" @click="promptAddNewBankInformation()"  icon-pack="feather" icon="icon-plus">Add</vs-button>

        <div class="vx-col w-full mb-base">
            <template>
                <vs-table stripe v-model="selected"  search  :data="employeeBankInformation">
                    <template slot="thead">
                        <vs-th>Bank</vs-th>
                        <vs-th>Account Type</vs-th>
                        <vs-th>Account No.</vs-th>
                        <vs-th>Period</vs-th>
                        <vs-th>Cash?</vs-th>
                        <vs-th>Used?</vs-th>
                        <vs-th>Action</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].bankId">
                                {{ bankName(data[indextr].bankId).bankName }}
                            </vs-td>
                            <vs-td :data="data[indextr].bankType">
                                {{bankTypeName(data[indextr].bankType).accountType}}
                            </vs-td>
                            <vs-td :data="data[indextr].accountNumber">
                                {{data[indextr].accountNumber }}
                            </vs-td>
                            <vs-td :data="data[indextr].periodId">
                                {{periodName(data[indextr].periodId).periodName}}
                            </vs-td>
                            <vs-td :data="data[indextr].isCash">
                                <vs-checkbox v-model="data[indextr].isCash" disabled="true" />
                            </vs-td>
                            <vs-td :data="data[indextr].isUsed">
                                <vs-checkbox v-model="data[indextr].isUsed" disabled="true" />
                            </vs-td>
                            <vs-td>
                                <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                                    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].id)" />
                                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr].id)" />
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </template>
             
        </div>

            <!-- ADD BANK INFORMATION -->
            <vs-prompt
                class="email-compose"
                title="Bank Information"
                accept-text= "Submit"
                @accept="onAddBankInformation"
                :is-valid="validForm"
                :active.sync="activePromptNewBankInformation">
                <vx-card title="Fill-out the following information">


                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Bank</span><span style="color:red">*</span>
                        <v-select name="bank-name" v-model="bank" label="bankName" :options="getBankLookup" placeholder="Please Select" />

                    </div>
                </div>
              
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Account Type</span><span style="color:red">*</span>
                        <v-select  v-model="bankType" label="accountType" :options="getAccountTypeLookup" placeholder="Please Select"/>

                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4" >
                        <span  class="text-sm">Account No</span><span v-if="this.isCash != true" style="color:red">*</span>
                        <vs-input v-validate="'numeric'" name="account number" v-model="accountNumber" placeholder="Account Number" :disabled="isCash"/>
                        <span class="text-danger text-sm" v-show="errors.has('account number')">{{ errors.first('account number') }}</span>

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full mb-2" >
                        <span  class="text-sm">Period</span><span style="color:red">*</span>
                        <v-select name="cert-name" class="w-full" v-model="period" label="periodName" :options="getPeriodLookup" placeholder="Please Select"/>
                    </div>
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col w-full mb-2">
                        <vs-checkbox   v-model="isCash"> Cash?</vs-checkbox>
                    </div>
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col w-full mb-2">
                        <vs-checkbox  v-model="isUsed">Used?</vs-checkbox>
                    </div>
                </div>
            
                </vx-card>
            </vs-prompt>




                 <!-- EDIT BANK INFORMATION -->
            <vs-prompt
                class="email-compose"
                title="Bank Information"
                accept-text= "Submit"
                @accept="onEditBankInformation"
                :is-valid="validForm"
                :active.sync="activePromptEditBankInformation">
                <vx-card title="Fill-out the following information">


                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Bank</span><span style="color:red">*</span>
                        <v-select name="bank-name" v-model="bank" label="bankName" :options="getBankLookup" placeholder="Please Select"/>

                    </div>
                </div>
              
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Start Date</span>
                        <v-select  v-model="bankType" label="accountType" :options="getAccountTypeLookup" placeholder="Please Select"/>

                    </div>
                     <div class="vx-col sm:w-1/2 w-full mb-4" >
                        <span  class="text-sm">Account No</span><span v-if="this.isCash != true" style="color:red">*</span>
                        <vs-input v-validate="'numeric'" name="account number" v-model="accountNumber" placeholder="Account Number" :disabled="isCash"/>
                        <span class="text-danger text-sm" v-show="errors.has('account number')">{{ errors.first('account number') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full mb-2" >
                        <span  class="text-sm">Period</span><span style="color:red">*</span>
                        <v-select name="cert-name" class="w-full" v-model="period" label="periodName" :options="getPeriodLookup" placeholder="Please Select"/>
                    </div>
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col w-full mb-2">
                        <vs-checkbox   v-model="isCash"> Cash?</vs-checkbox>
                    </div>
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col w-full mb-2">
                        <vs-checkbox  v-model="isUsed">Used?</vs-checkbox>
                    </div>
                </div>

            
                </vx-card>
            </vs-prompt>
        </vx-card>
    </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    data() {
        return {
            selected            : [],
            id                  : 0,
            bank                : [],
            bankType            : [],
            period              : null,
            accountNumber       : '',
            isCash              : false,
            isUsed              : true,
            userId              : null,

            paymentModeId       : null,

            uid                 : null,
            activePromptNewBankInformation    : false,
            activePromptEditBankInformation    : false,

            format: "d MMMM yyyy",
        }
    },
    created() {
            this.$vs.loading()
            // this.$store.dispatch('hrms/getAllBankInformation', { userId : null})
            this.$store.dispatch('lookup/getAllBankLookup')
            this.$store.dispatch('lookup/getAllPeriodLookup')
                .then(res => { this.$vs.loading.close() })
                .catch(error => { 
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                        })
                })
            this.uid = this.$route.params.id
            this.employeeBankInformation = this.uid
            this.employeeSalaryInformation = this.uid
            
    },
    computed: {
        employeeBankInformation: {
           
           get() { return this.$store.state.hrms.employeeBankInformation },
           set(value) { this.$store.dispatch('hrms/getAllBankInformation',  value )}
            
        },
        employeeSalaryInformation: {
            get() { return this.$store.state.hrms.employeeSalaryInformation},
            set(value) { this.$store.dispatch('hrms/getAllSalaryInformation', value) }
        },
        validForm(){
            return this.bank != null && this.bankType != null &&
            this.period != null && (this.isCash == false ?  this.accountNumber != '' :  this.accountNumber == '' )
        },
        getBankLookup() {
            return this.$store.state.lookup.getAllBankLookup
        },
        getAccountTypeLookup(){ 
            return this.$store.state.lookup.accountType
        },
        getPeriodLookup() {
            //console.log('PERIOD')
            //console.log(this.$store.getters['lookup/periodLookupByPaymentMode'](this.getPaymentModeId))
            return this.$store.getters['lookup/periodLookupByPaymentMode'](this.getPaymentModeId)
        },
        bankName() {
            return (id) => this.$store.getters['lookup/bankLookup'](id)
        },
        bankTypeName() {
            return (id) => this.$store.getters['lookup/accountType'](id)
        },
        periodName() {
            return (id) => this.$store.getters['lookup/periodLookup'](id)
        },
        getPaymentModeId() {
            // //console.log('PAYMENTMODE')
            // //console.log(this.$store.state.hrms.employeeSalaryInformation.paymentModeId)
            return this.$store.state.hrms.employeeSalaryInformation.paymentModeId
        }
        
        
    },
 
    methods: {
        promptAddNewBankInformation() {
            this.activePromptNewBankInformation = true
        },
        onAddBankInformation() {
            this.$validator.validateAll().then(result => {
            if (result) {
                    this.$vs.loading()

                    const data = {
                        bankId: this.bank.bankId,
                        bankType: this.bankType.value,
                        periodId: this.period.periodId,
                        accountNumber: this.accountNumber,
                        isCash: this.isCash,
                        isUsed:this.isUsed,
                        userId: this.uid,
                        currentUserId           : this.$store.state.AppActiveUser.uid
                    }
                    //console.log("BANK")
                    //console.log(data)
                    this.$store.dispatch('hrms/AddBankInformation', data)
                    .then((response) =>{
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Success',
                            text: 'Accredition Saved',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'success'                  
                            })
                    })
                    .catch(error => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
                    })
            } else {
            // form have errors
              this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
            }
            })
        },
        onEditBankInformation() {
            this.$validator.validateAll().then(result => {
            if (result) {
                    const data = {
                        id              : this.id,
                        bankId          : this.bank.bankId,
                        bankType        : this.bankType.value,
                        periodId        : this.period.periodId,
                        accountNumber   : this.accountNumber,
                        isCash          : this.isCash,
                        isUsed          : this.isUsed,
                        userId          : this.uid,
                        currentUserId           : this.$store.state.AppActiveUser.uid
                    }
                    this.$store.dispatch('hrms/UpdateBankInformation', data)
                        .then(response => {
                                this.$vs.loading.close()
                                this.$vs.notify({
                                title: 'Success',
                                text: 'BankInformation Updated',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle',
                                color: 'success'                  
                                })
                        })
                        .catch(error => {
                                this.$vs.loading.close()
                                this.$vs.notify({
                                title: 'Error',
                                text: error.message,
                                iconPack: 'feather',
                                icon: 'icon-x-octagon',
                                color: 'danger'
                            })
                        })
                } else {
            // form have errors
              this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
            }
            })
        },
        editRecord(Id) {

            const e = this.$store.getters['hrms/employeeBankInformation'](Id)
            this.id = e.id,
            this.bank = this.bankName(e.bankId),
            this.bankType = this.bankTypeName(e.bankType),
            this.period = this.periodName(e.periodId)
            this.accountNumber = e.accountNumber,
            this.isCash = e.isCash,
            this.isUsed = e.isUsed,
            this.userId = e.userId

            this.activePromptEditBankInformation = true
        },
        confirmDeleteRecord(id) {
            this.$store.dispatch('hrms/DeleteBankInformation', id)
            .then(res => {
                this.$vs.loading.close()
                        this.employeeBankInformation = this.uid
                        this.$vs.notify({
                        title: 'Success',
                        text: 'BankInformation Deleted',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                   })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
        }
    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        // VuePerfectScrollbar,
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>